// extracted by mini-css-extract-plugin
export default {"head-child":"l1ObjectDetail_head-child__GHh+P","list":"l1ObjectDetail_list__E+WEE"};